import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-delete-transfer',
  templateUrl: './delete-transfer.component.html',
  styleUrls: ['./delete-transfer.component.css']
})
export class DeleteTransferComponent implements OnInit {

  data: any;
  i: any;
  deleteId: any = "";
  materials: any = [];
  transferdata: any = [];
  transfer: any = [];

  pageNumber: number = 0;
  totalRecords: number = 0;
  recordsPerPage:number = 10;
  tableSize: number = 10;

 constructor( private toastr: ToastrService,private generic_service: GenericService) { }

ngOnInit(): void {
  this.getAllTransfer(this.pageNumber,this.recordsPerPage)
}

 

cancelModel(){
  document.getElementById("closeModalButton1")?.click()
}

onTableDataChange(event: any) {
  this.pageNumber = event;
  this.getAllTransfer(this.pageNumber-1,this.recordsPerPage)
}

getAllTransfer(pageNumber:any,recordsPerPage:any){
  this.generic_service.getAllTransfer(pageNumber,recordsPerPage).subscribe(
    (response:any)=>{
      this.materials = response.response.materialTransferList;
      this.totalRecords = response.response.totalRecords;
      console.log(response)
    }
  )
}

checkPage(){
  let pageNumber = 0
  if(this.pageNumber == 0){
    pageNumber = this.pageNumber
  }else{
    pageNumber = this.pageNumber-1
  }
}

deleteTransfer(){
  this.generic_service.deleteTransfer(this.deleteId).subscribe(
  (res:any)=>{
    console.log(res)
    this.toastr.success("Successfully deleted");
    this.getAllTransfer(this.pageNumber-1,this.recordsPerPage)
    this.cancelModel();
  },err=>{
    console.log(err)
    this.toastr.error(err.error.errors[0].description);
  }
  )
}

del(id:any){
this.deleteId = id
}

 

 
}
